module.exports = __webpack_public_path__ + "images/stickers/pete-busy.1aa41aedefce2ce80e27.png";